import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

interface Props {
  label: string;
  valid: boolean;
}

const ValidatedInfoChip: React.FC<Props> = ({ label, valid }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        width: "fit-content",
        backgroundColor: "#D4D6DB",
        borderRadius: "4px",
        mt: 2,
        px: 2,
        py: 0.5,
      }}
    >
      {valid ? <CheckCircleIcon
        sx={{
          color: "#16A34A",
          fontSize: 14,
        }}
      /> : <CancelIcon
        sx={{
          color: "#DC2626",
          fontSize: 14,
        }}
      />}
      

      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: "#1F2937",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default ValidatedInfoChip;